export default __webpack_public_path__ + "static/media/search-circle.8e0d0e1c.svg";